import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { Profile } from 'types'
import { getApiBaseUrl, prepareHeaders, getApiConfigKey } from 'utility/Api'
import apiConfig from './api-config'

const baseUrl = getApiBaseUrl()
const configKey = getApiConfigKey()
const apiPath = apiConfig[configKey].paths.apiPathDigitalId ?? ''

export const DigitalIdApi = createApi({
  reducerPath: 'digitalIdApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseUrl}/${apiPath}`,
    prepareHeaders: async headers => await prepareHeaders(headers)
  }),
  endpoints: builder => ({
    getProfile: builder.query<Profile, void>({
      query: () => 'profile'
    }),
    getProfilePictureUrl: builder.query<string, void>({
      query: () => {
        return {
          url: 'picture',
          method: 'GET',
          responseHandler: async response => {
            return await response.blob() // Need to specify this otherwise it tries to JSON.parse response, causing error
          }
        }
      },
      transformResponse: (response: Blob, meta, arg) => {
        return URL.createObjectURL(response)
      }
    }),
    searchPerson: builder.query<Profile[], string>({
      query: q => `search?q=${q}`
      // transformResponse: (response: Profile[]) => {
      //   return response.map(row => ({ id: row.mit_id, name: row.display_name }))
      // }
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetProfileQuery, useGetProfilePictureUrlQuery, useSearchPersonQuery } = DigitalIdApi
